import { createFileRoute, redirect } from "@tanstack/react-router";

// Section of the account page since the Konto views merged; keep the URL working.
export const Route = createFileRoute("/_app/account/sikkerhet")({
	beforeLoad: () => {
		throw redirect({ to: "/account", hash: "sikkerhet" });
	},
});
